module.exports = __webpack_public_path__ + "img/r-icon-2.9ddd5ad2.png";